import { useEffect, useRef } from "react";
import useTranslation from "../../hooks/i18n/useTranslation";
import IconsEnum from "../../classes/enums/IconsEnum";
import IconButton from "../iconButton/IconButton";

import "./IncrementDecrementButtons.css";

const IncrementDecrementButtons = ({
  onIncrement,
  onDecrement,
  onIncrementEnd,
  onDecrementEnd,
  disabled = false,
  debounceMs = 0,
}) => {
  const { t } = useTranslation();
  const debounceTimerRef = useRef(null);
  const lastValueRef = useRef(null);
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  const handleIncrementMouseDown = () => {
    if (disabled) return;
    onIncrement();
    // Add event listeners to handle mouse up and leave
    document.addEventListener("mouseup", handleIncrementEnd);
    document.addEventListener("mouseleave", handleIncrementEnd);
  };

  const handleDecrementMouseDown = () => {
    if (disabled) return;
    onDecrement();
    // Add event listeners to handle mouse up and leave
    document.addEventListener("mouseup", handleDecrementEnd);
    document.addEventListener("mouseleave", handleDecrementEnd);
  };

  const handleIncrementEnd = () => {
    if (debounceMs > 0 && onIncrementEnd) {
      if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
      debounceTimerRef.current = setTimeout(() => {
        onIncrementEnd();
      }, debounceMs);
    } else if (onIncrementEnd) {
      onIncrementEnd();
    }
  };

  const handleDecrementEnd = () => {
    if (debounceMs > 0 && onDecrementEnd) {
      if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
      debounceTimerRef.current = setTimeout(() => {
        onDecrementEnd();
      }, debounceMs);
    } else if (onDecrementEnd) {
      onDecrementEnd();
    }
  };

  return (
    <div className="IncrementDecrementButtons-container">
      <IconButton
        icon={IconsEnum.ARROWUP}
        onMouseDown={handleIncrementMouseDown}
        className="IncrementDecrementButtons-button IncrementDecrementButtons-button-up"
        disabled={disabled}
        title={t("428")}
      />
      <IconButton
        icon={IconsEnum.ARROWDOWN}
        onMouseDown={handleDecrementMouseDown}
        className="IncrementDecrementButtons-button IncrementDecrementButtons-button-down"
        disabled={disabled}
        title={t("429")}
      />
    </div>
  );
};

export default IncrementDecrementButtons;
